export const replaceFeedbackTerminology = (text: string): string => text;

export const replaceSourceTerminology = (text: string): string => text;
